<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'UnitPeriod',

    computed: {
      unitPeriod: {
        get() {
          return this.$store.state.unitPeriod
        },
        set(unitPeriod) {
          this.$store.commit('setUnitPeriod', unitPeriod)
        }
      },

      unitPeriodPath() {
        return 'universities/' + process.env.UNIVERSITY_ID +
               '/academic_periods/' + this.$route.params.period_id +
               '/university_layouts/' + this.$route.params.layout_id + '.json'
      }
    },

    created() {
      this.fetchData()
    },

    watch: {
      '$route': 'fetchData'
    },

    methods: {
      fetchData() {
        this.unitPeriod = null
        this.$http
          .get(this.unitPeriodPath)
          .then(response => {
            this.unitPeriod = response.data
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UnitPeriod.vue?0eb7dfcd